webpackJsonp([160146098055096],{

/***/ 1429:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"EncounterTypeSectionOverrideItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"aiInstructions","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"sectionName","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-encounter-type-section-override-item-input-fea89ae82a48d249600d.js